import { useEffect, useState } from "react";
import { SLOT_PX } from "../constants";

/**
 * Persistent vertical + horizontal calendar zoom (0.5×–2×).
 *
 * Exposes stable-derived pixel sizes so the callers don't have to
 * duplicate the clamping math. Values are written to localStorage on
 * change so the operator's preferred zoom survives a page refresh.
 */
export default function useCalendarZoom() {
  const [zoomV, setZoomV] = useState(() => {
    const v = parseFloat(localStorage.getItem("cal-zoom-v") || "1");
    return Number.isFinite(v) && v > 0 ? Math.min(2, Math.max(0.5, v)) : 1;
  });
  const [zoomH, setZoomH] = useState(() => {
    const v = parseFloat(localStorage.getItem("cal-zoom-h") || "1");
    return Number.isFinite(v) && v > 0 ? Math.min(2, Math.max(0.5, v)) : 1;
  });

  useEffect(() => { localStorage.setItem("cal-zoom-v", String(zoomV)); }, [zoomV]);
  useEffect(() => { localStorage.setItem("cal-zoom-h", String(zoomH)); }, [zoomH]);

  const bumpZoom = (which, delta) => {
    const clamp = (v) => Math.min(2, Math.max(0.5, Math.round(v * 100) / 100));
    if (which === "v") setZoomV((z) => clamp(z + delta));
    else setZoomH((z) => clamp(z + delta));
  };

  return {
    zoomV,
    zoomH,
    bumpZoom,
    slotPx: Math.max(10, Math.round(SLOT_PX * zoomV)),
    colMinW: Math.max(90, Math.round(140 * zoomH)),
  };
}
